module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/kuoxEJKdryC2CmaCIyU4E-85353788e07afed2fd57e6432eb9ec24.jpg";